import { getElById } from "../../../../../util/varibles/global";
import { IActivityLog, IVessel, TOperation } from "../../../../../util/varibles/interface";
import { CALENDAR_ID } from "../../../constants";
import { convertPxToTimeByStep } from "../../../util";
import { updateTime } from "../../../util/function_operation/global";


const EDGE_SIZE = 50;
const LEFT_SIDEBAR_WIDTH = 110;
const MIN_SCROLL_SPEED = 2;
const MAX_SCROLL_SPEED = 18;

interface IHandleScroll {
    operationClientLeft: number;
    operationClientRight: number;
    clientY: number;
    activityLogs: Record<string, IActivityLog[]>;
    key: string;
    maxScrollLeft: number;
    action(activityLogs: Record<string, IActivityLog[]>): void;
    moveHorizontal(distance: number): void;
}

const getScrollSpeed = (distance: number) => {
    if (distance <= 0) {
        return 0;
    }

    return Math.min(
        MAX_SCROLL_SPEED,
        Math.max(MIN_SCROLL_SPEED, distance / EDGE_SIZE * MAX_SCROLL_SPEED)
    );
};

/*
* Date: 24/07/2020
* Author: Vinh.Pham
* Description: Loads more data when scrolling
 */
export const handleScroll = ({
    operationClientLeft,
    operationClientRight,
    clientY,
    activityLogs,
    key,
    maxScrollLeft,
    action,
    moveHorizontal
}: IHandleScroll) => {
    const element = getElById(CALENDAR_ID);
    const activityLog = activityLogs[key];

    if (!element || !activityLog) {
        return false;
    }

    const { top, right, bottom, left } = element.getBoundingClientRect();
    const horizontalStart = left + LEFT_SIDEBAR_WIDTH;

    const distanceRight = operationClientRight - (right - EDGE_SIZE);
    const distanceLeft = horizontalStart + EDGE_SIZE - operationClientLeft;
    const distanceBottom = clientY - (bottom - EDGE_SIZE);
    const distanceTop = top + EDGE_SIZE - clientY;

    const velocityX = distanceRight > 0
        ? getScrollSpeed(distanceRight)
        : distanceLeft > 0
            ? -getScrollSpeed(distanceLeft)
            : 0;
    const velocityY = distanceBottom > 0
        ? getScrollSpeed(distanceBottom)
        : distanceTop > 0
            ? -getScrollSpeed(distanceTop)
            : 0;

    const oldScrollLeft = element.scrollLeft;
    const oldScrollTop = element.scrollTop;

    if (velocityX !== 0) {
        if (velocityX > 0) {
            element.scrollLeft = oldScrollLeft < maxScrollLeft
                ? Math.min(maxScrollLeft, oldScrollLeft + velocityX)
                : oldScrollLeft;
        } else {
            element.scrollLeft = Math.max(0, oldScrollLeft + velocityX);
        }
    }
    if (velocityY !== 0) {
        element.scrollTop += velocityY;
    }

    const horizontalChange = element.scrollLeft - oldScrollLeft;
    const verticalChange = element.scrollTop - oldScrollTop;

    if (horizontalChange !== 0) {
        moveHorizontal(horizontalChange);
    }

    if (verticalChange !== 0) {
        const duration = convertPxToTimeByStep(verticalChange);

        if (duration !== 0) {
            action({
                ...activityLogs,
                [key]: updateTime(activityLog, duration)
            });
        }
    }

    return horizontalChange !== 0 || verticalChange !== 0;
}

export const createKeyActivityLog = (operation: TOperation, vessel: IVessel) => {
    const { start_place_id = '' } = operation;
    return [vessel.id, start_place_id].join("|");
}
